(function () {

    a3_cabin_reports.directive('courseReadOnly', courseReadOnly);

       /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name courseReadOnly
   * @restrict E
   * @description
   *   Initialize read only view of what was submitted
   * @example
   *   Usage:
   *   <course-read-only></course-read-only>
   * @ngInject
   */

    function courseReadOnly() {
        function link(scope) {
            scope.leftScroll = leftScroll;
            scope.rightScroll = rightScroll;
            scope.selectedTraineeSession = selectedTraineeSession;
            scope.selected = false;
            scope.selectedAbsentTraineeSession = selectedAbsentTraineeSession;
    
            scope.selectedPhase = scope.phases.find(x => x.PhaseId == scope.session.PhaseId);

            scope.selectedTraineeBadge = {
                crewId: scope.session.TraineesSessions[0].CrewId
            }; 

            function leftScroll() {
                document.querySelector('.horizontal-scroll').scrollLeft -= 500;
            }
            
            function rightScroll() {
                document.querySelector('.horizontal-scroll').scrollLeft += 500;
            }       

            
            function selectedTraineeSession() {   
                return function( traineeSession ) {
                    var showSession = false;
                    if (traineeSession.CrewId === scope.selectedTraineeBadge.crewId){
                        showSession = true;
                    }
                    return showSession;
                };
            }

            function selectedAbsentTraineeSession() {   
                return function( traineeSession ) {
                    var showPanel = false;
                    if (traineeSession.CrewId === scope.selectedTraineeBadge.crewId && traineeSession.Items.length == 0){
                        showPanel = true;
                    }
                    return showPanel;
                };
            }
         
        }
        return {
            restrict: 'E',
            templateUrl: "views/TrainingReadOnly/course-read-only.tpl.html",
            scope : { phases:"=", session:"="},
            terminal: true,
            link: link
        }
    }
})();